/* tslint:disable */
/* eslint-disable */
/**
 * API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { CallSettings } from './CallSettings';
import {
  instanceOfCallSettings,
  CallSettingsFromJSON,
  CallSettingsFromJSONTyped,
  CallSettingsToJSON,
} from './CallSettings';
import type { SmsSettings } from './SmsSettings';
import {
  instanceOfSmsSettings,
  SmsSettingsFromJSON,
  SmsSettingsFromJSONTyped,
  SmsSettingsToJSON,
} from './SmsSettings';

/**
 * @type RuleSettings
 *
 * @export
 */
export type RuleSettings = CallSettings | SmsSettings;

export function RuleSettingsFromJSON(json: any): RuleSettings {
  return RuleSettingsFromJSONTyped(json, false);
}

export function RuleSettingsFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): RuleSettings {
  if (json == null) {
    return json;
  }

  // rule order was changed in generate-api.cjs
  if (instanceOfSmsSettings(json)) {
    return SmsSettingsFromJSONTyped(json, true);
  }
  if (instanceOfCallSettings(json)) {
    return CallSettingsFromJSONTyped(json, true);
  }
}

export function RuleSettingsToJSON(value?: RuleSettings | null): any {
  if (value == null) {
    return value;
  }

  // rule order was changed in generate-api.cjs
  if (instanceOfSmsSettings(value)) {
    return SmsSettingsToJSON(value as SmsSettings);
  }
  if (instanceOfCallSettings(value)) {
    return CallSettingsToJSON(value as CallSettings);
  }

  return {};
}
